import type { MarketplaceProduct } from '@/types';
import { EmptyState } from '@/components/ui';
import { PackageSearch } from 'lucide-react';
import { ProductCard } from './ProductCard';

interface ProductGridProps {
  products: MarketplaceProduct[];
  linkBase: string;
  loading?: boolean;
  onAddToCart?: (product: MarketplaceProduct) => void;
}

function SkeletonCard() {
  return (
    <div className="overflow-hidden rounded-xl border border-gray-200 bg-white">
      <div className="aspect-[3/2] w-full animate-pulse bg-gray-100" />
      <div className="space-y-2 p-4">
        <div className="h-3 w-1/3 animate-pulse rounded bg-gray-100" />
        <div className="h-4 w-2/3 animate-pulse rounded bg-gray-100" />
        <div className="h-3 w-full animate-pulse rounded bg-gray-100" />
        <div className="h-6 w-1/2 animate-pulse rounded bg-gray-100" />
      </div>
    </div>
  );
}

export function ProductGrid({ products, linkBase, loading, onAddToCart }: ProductGridProps) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 8 }).map((_, i) => <SkeletonCard key={i} />)}
      </div>
    );
  }
  if (products.length === 0) {
    return <EmptyState icon={PackageSearch} title="No results" description="Try adjusting your filters or search." />;
  }
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
      {products.map((p) => (
        <ProductCard key={p.id} product={p} linkBase={linkBase} onAddToCart={onAddToCart} />
      ))}
    </div>
  );
}
